

const utils = {
    breakpoints: {
        palm: '(max-width: 767px)',
        'lap-and-up': '(min-width: 768px)',
    },
};

module.exports = utils;



// WEBPACK FOOTER //
// ./source/scripts/utils.js